import React, { useState } from 'react';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';


interface IPartnerDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const PartnerDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IPartnerDetailsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }
    const partner = data
    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Partner Details</p>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                        <div className='mb-4'>
                            <p className='font-bold'>Name</p>
                            <p>{partner?.name}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Username</p>
                            <p>{partner?.username}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Email</p>
                            <p>{partner?.email}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Is Enabled</p>
                            <p>{partner?.enabled ? 'Yes' : 'No'}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Company Name</p>
                            <p>{partner?.companyName}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Country</p>
                            <p>{partner?.country}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Company Registration Number</p>
                            <p>{partner?.companyRegistrationNumber}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Phone Number</p>
                            <p>{partner?.phoneNumber}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Annual Turnover</p>
                            <p>{partner?.annualGMV}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>VAT Number</p>
                            <p>{partner?.vatNumber}</p>
                        </div>
                    </div>
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less my-9 min-w-full !shadow-none'}
                        type='submit'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default PartnerDetailsModal;